import _ from 'lodash';
import Sort, { COLUMN_KEY, DIRECTION_KEY } from 'records/Sort';

export default class ListUtilities {

    /**
     * 
     * @param {Object} element lodash sort input
     * @param {String} column column name string
     * @returns processed output data point
     */
    static _getSorter = (element, column) => {
        const value = element[column];
        switch (typeof value) {
            case 'string':
                const trimmedValue = value.trim();
                return trimmedValue ? trimmedValue.toLowerCase() : null;
            case 'object':
                return value instanceof Array ? value.length : value
            default:
                return value;
        }
    };

    /**
     * Sort and return the sorted list of objects
     * @param {List} array list of objects eg: [{a:1,b:2},{a:2,b:3}]
     * @param {Record} primarySort column name to be sorted eg: {"column":"a","direction":"asc"}
     * @param {Record} secondarySort direction to be sorted eg: {"column":"b","direction":"asc"}
     * @returns sorted object list
     */
    static sortByColumn = (array, primarySort, secondarySort) => {
        const primary = new Sort(primarySort);
        const secondary = new Sort(secondarySort);
        const primaryColumn = primary.get(COLUMN_KEY);
        const secondaryColumn = secondary.get(COLUMN_KEY);

        if (!primaryColumn) {
            return array;
        }

        if (!Array.isArray(array) || !array.length) {
            return [];
        }

        const sorters = [element => ListUtilities._getSorter(element, primaryColumn)];
        const directions = [primary.get(DIRECTION_KEY)];

        if (secondaryColumn) {
            sorters.push(element => ListUtilities._getSorter(element, secondaryColumn));
            directions.push(secondary.get(DIRECTION_KEY));
        }

        return _.orderBy(array, sorters, directions);
    }

    /**
     * Get maximum property value from a list of objects
     * @param {List} array list of objects eg: [{a:1,b:2},{a:2,b:3}]
     * @param {String} column column name to be sorted eg: "a"
     * @param {String} requiredField column name required of the maximum eg: "b"
     * @returns maximum prop value eg: 3
     */
    static getMaximumPropValue = (array, column, requiredField) => {
        if (!Array.isArray(array) || !array.length || !column) {
            return null;
        }
        const result = _.maxBy(array, element => element[column]);
        return requiredField ? result[requiredField] : result[column];
    }
}
